import { FC } from "react";

const ResetPasswordProps = {
    nom:String,
};

const ResetPassword: FC<any> =() => {

    return ( <></>);
}
export default ResetPassword;